import { InjectionToken } from '@angular/core';
import type * as Rx from 'rxjs';

export const WEBSOCKET_TEST_SCHEDULER = new InjectionToken<Rx.SchedulerLike>(
  'WebsocketTestScheduler',
);

export const RECONNECT_CONFIG = new InjectionToken<Rx.SchedulerLike>(
  'Reconnect Configuration',
);

export const RANDOM_NUMBER_PROVIDER = new InjectionToken<Rx.SchedulerLike>(
  'Random Number Provider',
);

export enum OnMessageTrackedEventTypes {
  MESSAGES_PRIVATE = 'messages-private',
}

export const ON_MESSAGE_TRACKING_CONFIG: {
  readonly [index: string]: boolean;
} = {
  [OnMessageTrackedEventTypes.MESSAGES_PRIVATE]: true,
};

/**
 * List of users who's websocket messages for the messaging product are being tracked. This is temporary and will be removed.
 *
 * @see T271701
 */
export const ON_MESSAGE_TRACKING_USER_CONFIG = new Set([
  // Users we are logged in as on test devices and tracking
  26_707_374, 1_089_884, 1_646_166, 10_408_748, 16_629_674,
  // AnilRecruiter
  58_349_233,

  // Users who complained about messaging performance/reliability
  60_808_159, 4_076_136, 15_782_095, 15_555_206, 34_401_494, 55_019_610,
  27_183_142, 23_186_969, 28_089_368, 25_391_384, 58_061_229, 13_424_957,
  212_547, 21_226_429, 60_541_789, 33_028_117, 59_833_470, 52_418_007,
  13_299_756, 58_482_303, 57_538_014, 7_920_909, 40_902_720,

  59_924_844, 48_713_282,

  // Support agents
  35_863_928, 46_346_499, 23_989_804, 54_084_163, 21_571_175, 11_297_398,
  19_686_403,

  // Messaging team
  55_950_625, 56_658_423, 30_609_349, 21_178_223, 31_575_919, 53_656_246,
  52_769_470,
]);
